import Splide from '@splidejs/splide';
import {AutoScroll} from '@splidejs/splide-extension-auto-scroll';
( function( app ) {
  const COMPONENT = {
    init: function() {
      if ( $( '.scrolling-cta__splide' ).length ) {
        $( '.scrolling-cta__splide' ).each( function( index, element ) {
          const slider = new Splide( element, {
            type: 'loop',
            gap: '48px',
            perPage: 7,
            perMove: 1,
            pagination: false,
            arrows: false,
            speed: 1200,
            direction: 'ttb',
            height: '600px',
            pauseOnHover: false,
            drag: false,
          } );
          slider.mount( {AutoScroll} );
        } );
      }
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'scrolling-cta', COMPONENT );
} )( app );
